<template>
  <div class="create-account">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <login-layout v-if="!loading">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <gappt-menu class="ma-4" :user="user"></gappt-menu>
      </v-row>
      <div class="pa-6">

        <v-row class="display-1" justify="center">
          Create an account
        </v-row>

        <v-form
          lazy-validation
          class="ma-3">

          <v-alert type="error" v-if="formState.error.length" dismissible>
            {{ formState.error }}
          </v-alert>
          <v-alert type="success" v-if="formState.success.length" dismissible>
            <p>{{ formState.success }}</p>
            <v-btn color="white darken-1" outlined @click="reset()">Create a new one</v-btn>
          </v-alert>

          <v-row>
            <v-select
              v-model="resource.type_id"
              :items="resource_types"
              label="Resource type"
              dense
              solo
              item-text="title"
              item-value="id"
              :error="!$v.resource.type_id.required&&formState.validation"
              :error-messages="!$v.resource.type_id.required&&formState.validation?'Resource type is required':''"
            ></v-select>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="resource.title"
                label="Title"
                name="title"
                type="text"
                color="primary darken-4"
                :error="!$v.resource.title.required&&formState.validation"
                :error-messages="!$v.resource.title.required&&formState.validation?'Resource title is required':''"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="resource.sub_title"
                label="Sub title"
                name="sub_title"
                type="text"
                color="primary darken-4"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="resource.external_id"
                label="External ID"
                name="external_id"
                type="text"
                prepend-icon="vpn_key"
                color="primary darken-4"
                :error="!$v.resource.external_id.required&&formState.validation"
                :error-messages="!$v.resource.external_id.required&&formState.validation?'External ID is required':''"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="resource.icon"
                label="Icon URL"
                name="icon"
                prepend-icon="insert_photo"
                type="text"
                color="primary darken-4"
                :error="!$v.resource.icon.url&&formState.validation"
                :error-messages="!$v.resource.icon.url&&formState.validation?'Icon must be a proper URL':''"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-btn large
                 color="primary darken-4 white--text"
                 :disabled="formState.sending"
                 @click="submit">
            Save
          </v-btn>
        </v-form>
      </div>
    </login-layout>
  </div>
</template>
<script>
    import { required, url } from 'vuelidate/lib/validators';
    import GapptMenu from "./Menu";
    import User from "../models/user";

    export default {
        name: "CreateAccount",

        components: { GapptMenu },

        data() {
            return {
                user: {},
                resource: {
                    type_id: null,
                    title: '',
                    sub_title: '',
                    external_id: '',
                    icon: '',
                },
                resource_types: [],
                formState: {
                    sending: false,
                    validation: false,
                    error: '',
                    success: ''
                },
            }
        },

        validations: {
            resource: {
                type_id: { required },
                title: { required },
                external_id: { required },
                icon: { url },
            }
        },

        computed: {
            loading () {
                return this.$store.state.loading
            },
        },

        mounted() {
            this.getData()
            this.resource.external_id = this.uuidv4()
        },

        methods: {
            submit() {
                this.formState.validation = true;
                this.$v.resource.$touch();

                if (this.$v.$invalid) {
                    this.formState.sending = false;
                } else {
                    this.$store.commit('loadingOn')
                    this.formState.sending = true;
                    this.formState.error = '';

                    this.$resourceService.addResource(this.resource)
                        .then(() => {
                            this.formState.success = 'The account has been created.';
                        })
                        .catch((error) => {
                            this.formState.error = error.response.data.error;
                        }).finally(() => {
                        this.formState.sending = false
                        this.$store.commit('loadingOff')
                        window.scrollTo({top:0});
                    });
                }
            },

            uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },

            reset() {
                this.resource = {
                    type_id: null,
                    title: '',
                    sub_title: '',
                    external_id: '',
                    icon: '',
                }
                this.$set(this.resource, 'external_id', this.uuidv4())
                this.formState.success = false
            },

            async getData() {
                this.$store.commit('loadingOn')

                Promise.all([
                    this.getResourceTypes(),
                    this.getUser(),
                ])
                    .finally(() => this.$store.commit('loadingOff'));
            },

            async getUser() {
                let userResponse = await this.$sessionService.current();
                this.user = new User(userResponse.login)
            },

            async getResourceTypes() {
                this.resource_types = await this.$resourceService.getResourceTypes();
            }
        }
    }
</script>
